

class ProductStates {

    static states = [{label: "Todos", value: 3}, {label: "Punteados", value: 2}, {label: "Sin puntear", value: 1}];

}

export default ProductStates;